// 官网不同环境的地址
export const xueshicloundHome = {
  'production': 'https://xueshicloud.com',
  'development': 'http://localhost:8063',
  'lan': 'http://192.168.1.124:8063'
}[process.env.NODE_ENV]

// 学识云不同环境的地址
export const xueshiclound = {
  'production': 'https://portal.xueshicloud.com',
  'development': 'http://localhost:8062',
  'lan': 'http://192.168.1.124:8062'
}[process.env.NODE_ENV]

/**
 * 跳转到首页
 */
export function getHomePage () {
  return xueshicloundHome
}

/**
 * 跳转到个人信息页
 */
export function getUserInfoPage () {
  return `${xueshiclound}/user/account`
}

/**
 * 跳转到控制台页
 */
export function getConsolePage () {
  return `${xueshiclound}/console`
}



// WEBPACK FOOTER //
// ./src/utils/assist.js